import { render, staticRenderFns } from "./SlideContent.vue?vue&type=template&id=460c9f4b&scoped=true"
import script from "./SlideContent.vue?vue&type=script&lang=js"
export * from "./SlideContent.vue?vue&type=script&lang=js"
import style0 from "./SlideContent.vue?vue&type=style&index=0&id=460c9f4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c9f4b",
  null
  
)

export default component.exports